import React from 'react';
import { Container, TabContent, TabPane, Nav, NavItem, NavLink, Row, Col } from "reactstrap";
import classnames from 'classnames';
import refereed from '../refereed.json';
import refereedconf from '../refereedConf.json';
import nonrefereed from '../nonrefereed.json';
import { titleCase } from "title-case";

class Publication extends React.Component {
    constructor(props) {
      super(props);
  
      this.toggle = this.toggle.bind(this);
      this.state = {
        activeTab: '1'
      };
    }
  
    toggle(tab) {
      if (this.state.activeTab !== tab) {
        this.setState({
          activeTab: tab
        });
      }
    }
  
    render() {
      return <div>
        <Container>
          <Nav tabs>
            <NavItem>
              <NavLink className={classnames({ active: this.state.activeTab === '1' })}
                       onClick={() => { this.toggle('1'); }}>
                Peer-Reviewed (Refereed) journals
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink className={classnames({ active: this.state.activeTab === '2' })}
                       onClick={() => { this.toggle('2'); }}>
                Refereed Conference Proceedings
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink className={classnames({ active: this.state.activeTab === '3' })}
                       onClick={() => { this.toggle('3'); }}>
                Non-Refereed
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={this.state.activeTab}>
            <TabPane tabId="1">
            <RenderBibl bibl={refereed}/>
            </TabPane>
            <TabPane tabId="2">
              <RenderBibl bibl={refereedconf}/>
            </TabPane>
            <TabPane tabId="3">
              <RenderBibl bibl={nonrefereed}/>
            </TabPane>          
          </TabContent>
        </Container>
      </div>;
    }
  }

  function getauthor(author){
    let list_author = [];
    let new_author ='';
    let given_name;
    let me;
    let len_author = author.length > 9 ? 8: author.length;
    for (var j=0; j<len_author;j++){
      if(author[j].family === 'Rajoelimanana'){
        me = j; 
      }
      given_name = author[j].given.split(' ').map(function (res1,i){return res1[0]});
      if(given_name.length > 1){
        given_name = given_name.reduce(function (total, num) {return total+"."+num+'.'});
      } else{
        given_name = given_name+'.';
      }
      new_author = author[j].family+' '+given_name;
      list_author.push({"authors":new_author, "me":me});
    }
    return list_author
  }

  class RenderBibl extends React.Component {
    render() {
        const bibl = this.props.bibl;
        return <Container style={{margin:"25px 0px"}}>
            <Row>
            <Col style={{padding:"0px"}}>
            <ul>
                {bibl.map(function (paper, i) {
                const author_list = getauthor(paper.author);
                const volume = typeof paper.volume === "undefined" ? '':', '+paper.volume;
                const title = titleCase(paper.title);
                const link = paper["URL"];
                const doi =  paper["DOI"];
                return(
                  <li key={i} style={{margin:"30px 0px"}}>
                  <RenderTitle title={title} link={link} />
                  <br />
                  <RenderAuthor authors={author_list} />
                  <span><font color="red"><i>{paper["container-title"]}</i></font>, <font color="black">{paper.issued['date-parts'][0][0]}</font><b>{volume}</b>, <i>{paper.page}</i></span>
                  <br />
                  <RenderBibLink ads={link} doi={doi}/>
                  </li>
                  )
                })
                }
            </ul>
            </Col>
            </Row>
        </Container>
        }
    }  

    class RenderTitle extends React.Component{
      render(){
        const title = this.props.title;
        const link = this.props.link;
        return(<a style={{color: "lightgreen", fontStyle:"italic"}} href={link} ><u>{title}</u></a>)
      }
    }

    class RenderBibLink extends React.Component{
      render(){
        const ads = this.props.ads;
        const doi = this.props.doi;
        return(<span className='bibmenu'>
        <a href={ads} >[ADS abstract]</a>
        {typeof doi !== "undefined" ? <a href={'http://dx.doi.org/'+doi}> [doi]</a>: ""} 
        </span>)
      }
    }
    
    class RenderAuthor extends React.Component {
      render(){
      const authors = this.props.authors;
      return (<span className="bibauthor">
        {authors.map(function (author, i) {
          if (author["me"] === i){
            return(<b>{author["authors"]+', '}</b>)
          } else{
            return(author["authors"]+', ');
          }
        })
      }
          </span>
        );
    }
  }


  export default Publication;